const KEY = (slug) => `ss_cart_${slug}`;

export function getCart(slug) {
  try { return JSON.parse(localStorage.getItem(KEY(slug)) || "[]"); } catch { return []; }
}
export function saveCart(slug, items) {
  localStorage.setItem(KEY(slug), JSON.stringify(items));
  window.dispatchEvent(new CustomEvent("cart-changed", { detail: { slug } }));
}
export function addToCart(slug, product, qty = 1) {
  const items = getCart(slug);
  const idx = items.findIndex((i) => i.product_id === product.id);
  if (idx >= 0) items[idx].quantity = Math.min(items[idx].quantity + qty, product.quantity);
  else items.push({ product_id: product.id, name: product.name, price: product.price, quantity: qty, photo_url: product.photo_url, max: product.quantity });
  saveCart(slug, items);
}
export function removeFromCart(slug, productId) {
  saveCart(slug, getCart(slug).filter((i) => i.product_id !== productId));
}
export function updateCartQty(slug, productId, qty) {
  const items = getCart(slug).map((i) => i.product_id === productId ? { ...i, quantity: Math.max(1, qty) } : i);
  saveCart(slug, items);
}
export function clearCart(slug) { saveCart(slug, []); }
